import { AppNS } from 'app';

import { RolesWithPermissions } from '../';

const EDIT_STATES: AppNS.TicketState[] = ['dob_action_required', 'subject_action_required'];
const ASSIGNMENT_STATES: AppNS.TicketState[] = ['dob_action_required', 'subject_action_required', 'denied'];

export const isStateEditable = (ticket: AppNS.Ticket) => EDIT_STATES.includes(ticket.state);
export const isStateEditableForAssignment = (ticket: AppNS.Ticket) => ASSIGNMENT_STATES.includes(ticket.state);

export const TICKETS_ROLES: RolesWithPermissions = {
  admin: {
    tickets: {
      view: true,
      create: false,
    },
  },
  general: {
    tickets: {
      view: true,
      create: false,
      assign: false,
    },
  },
  supervisor: {
    tickets: {
      view: true,
      create: true,
      assign: (currentUser, ticket) => isStateEditableForAssignment(ticket),
      update: (currentUser, ticket) => isStateEditable(ticket) && currentUser.id === ticket.reviewerId,
      enableActions: (currentUser, ticket) =>
        isStateEditableForAssignment(ticket) && currentUser.id === ticket.reviewerId,
    },
  },
  backoffice: {
    tickets: {
      view: true,
      create: true,
      assign: (currentUser, ticket) => isStateEditableForAssignment(ticket),
      update: (currentUser, ticket) => isStateEditable(ticket) && currentUser.id === ticket.reviewerId,
      enableActions: (currentUser, ticket) =>
        isStateEditableForAssignment(ticket) && currentUser.id === ticket.reviewerId,
    },
  },
  client: {
    tickets: {
      view: true,
      create: false,
    },
  },
  agency: {
    tickets: {
      view: true,
      create: false,
    },
  },
  '3rd_inspector': {
    tickets: {
      view: false,
      create: false,
    },
  },
  inspector: {
    tickets: {
      view: false,
      create: false,
    },
  },
};
